/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */

export const noSolutionAvail: number = -91012283; // this value indicates either no solution or invalid
export const noOption: number = -91412282; // this value indicates either no solution or invalid

export const fplOriginatorPhone: string = "+41 782 617 313";
export const placeHolderImage_dark: string =
  "data:image/png;base64,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";
export const placeHolderImage_light: string = placeHolderImage_dark;

export enum appearanceEnum {
  light = 0,
  dark = 1,
}
export enum fplState {
  virgin = 0,
  sent = 7,
  filed = 1,
  departed = 2,
  landed = 3,
  delayed = 4,
  edited = 5,
  canceled = 6,
}
export enum targetPlatformEnum {
  nil = 0,
  na = 1,
  pwa = 2,
  server = 3,
}
export enum flightRulesEnum {
  V = 0,
  I = 1,
  Y = 2,
  Z = 3,
}
export enum property {
  codeDescription = 1,
  acftReg = 2,
  acftType = 3,
  opsType = 4,
  opsMissionType = 5,
  estTimeDep = 6,
  estTimeArr = 7,
  icaoOrigin = 8,
  icaoDest = 9,
  icaoAlternate = 10,
  identOrigin = 11,
  identDest = 12,
  identAlternate = 13,
  atcFplSendStatusMsg = 14,
  pilotInCommand = 15,
  flightrules = 16,
  originCoords = 17,
  destinationCoords = 18,
  alternateCoords = 19,
  fplTypeOfFlight = 20,
  fplCruisingLevel = 21,
  fplCruisingLevelRef = 22,
  fplRoute = 23,
  fplEstTimeEnr = 24,
  fplRemarks = 25,
  estRouteDist = 26,
  fplId = 27,
  fplState = 28,
  originName = 29,
  destName = 30,
  alternateName = 31,
  fplEndurance = 32,

  // ops remarks
  opsRemarks = 50,

  // last briefing generated
  lastBriefingCreation = 51,

  // weight and balance
  dryOperatingMass = 100,
  dryCgPositionX = 101,

  takeOffFuelMass = 102,
  otherConsMass = 103,
  paxLoadMass = 104,
  cargoLoadMass = 105,
  takeOffMass = 106,
  estLandingMass = 107,
  zeroFuelMass = 108,
  takeOffcenterOfGravityX = 109,
  takeOffCenterOfGravityY = 110,
  estLandingCenterOfGravityX = 111,
  estLandingCenterOfGravityY = 112,
  maxTakeOffMass = 113,
  cgMinAtTakeOffMass = 114,
  cgMaxAtTakeOffMass = 115,
  maxPayloadLeftMtow = 116,
  maxFuelLoadLeftMtow = 117,
  crewMass = 118,
  emptyEquippedMass = 119,
  dryCgPositionY = 120,
  zeroFuelcenterOfGravityX = 121,
  zeroFuelcenterOfGravityY = 122,
  emptyEuippedcenterOfGravityX = 123,
  emptyEuippedcenterOfGravityY = 124,
  actNbrpersonsAboard = 125,

  codeDescr = 150,
  codeType = 152,
  codeDuty = 153,
  txtSeatPosition = 154,
  weightValue = 155,
  txtMail = 156,
  txtPhone = 157,
  valLimitMax = 158,
  valLimitMin = 159,
  valLoadArmX = 160,
  valLoadArmY = 161,
  valUsable = 162,
  valPriority = 163,
  txtCargoComp = 164,

  // navseg
  pointType = 200,
  ident = 201,
  elevation = 202,
  pointRelation = 203,
  deleted = 204,
  eventStatusActive = 205,
  pointSubType = 206,
  pointSubValue = 207,
  plannedOverflyTime = 208,
  plannedOverflyAltAmsl = 209,
  terrainClearance = 210,
  minSafeAlt = 211,
  magVar = 212,
  desig = 213,
  trueTrack = 214,
  magTrack = 215,

  // fuel
  tripFuel = 400,
  alternateFuel = 401,
  holdingFuel = 402,
  taxiFuel = 403,
  contingencyFuel = 404,
  additionalFuel = 405,
  ballastFuel = 406,
  extraFuel = 407,
  finalReserve = 408,
  reserveFuel = 409,
  minTakeOffFuelReq = 410,
  minRampFuelReq = 411,
  estLandingFuel = 412,
  actFuelOnBoard = 413,

  // performance
  oatOrigin = 500,
  oatDest = 501,
  qnhOrigin = 502,
  qnhDest = 503,

  depHeliHogeMass = 510,
  depHeliHogeMassLeft = 511,
  destHeliHogeMass = 512,
  destHeliHogeMassLeft = 513,

  depHeliVtolCatAMass = 514,
  depHeliVtolCatAMassLeft = 515,
  destHeliVtolCatAMass = 516,
  destHeliVtolCatAMassLeft = 517,

  depPressureAltitude = 518,
  destPressureAltitude = 519,
  depDensityAltitude = 520,
  desDensityAltitude = 521,

  desEstimatedHoistMass = 522,

  // Aircraft state record: param rows with the registration as hash and
  // tableSuffix "aircraft" (services/aircraft-state).
  acftFuelOnBoard = 600,
  acftFlightTimer = 601,
}
export enum opsTypeEnum {
  leisure = 1,
  commercialAirTransport = 2,
  ems = 3,
  ferry = 4,
  education = 5,
}
export enum opsMissionTypeEnum {
  all = 0,
  ems_rope = 1,
  ems_fire,
  ems_incubator,
  ems_avalanche,
  ems_organ,
  ems_night,
  ems_training,
  ems,
  vip,
  etops,
  ems_winch,
  ems_day,
  ems_inc,
}
export enum processResultStateEnum {
  unset = 0,
  ok = 1,
  warn = 2,
  fail = 3,
}
export class dutyOfpPerfEnvStruct {
  origin_qnh: number;
  dest_qnh: number;
  origin_elev: number;
  dest_elev: number;
  origin_oat: number;
  dest_oat: number;
}
export class loadingStruct {
  flightId: string;
  opsMissionType: opsMissionTypeEnum;
  parameters: string;
  variantDesig: string;
  loadingElements: parameterStruct[];
}
export enum payloadCodeTypeEnum {
  emptyWeight = 0,
  crew,
  pax,
  fuel,
  cargo,
  equipment,
  optionalEquipment,
  pic,
  fo,
  crewCargo,
  ballast,
}
export enum loadingElementDuty {
  pic = 1,
  fo,
  hcm,
  med,
}
export class dutyAuthStruct {
  flightCrewId: string;
  crewDesignator: string;
  pilotInCommand: string;
  missionLimits: limitsStruct;
  parameters: string;
  dutyFrom: number;
  dutyTo: number;
  created: number;
  signature: string;
}
export class limitsStruct {
  extraWeight: number;
  extraFuel: number;
  standardFuel: number;
  pilotNotes: string;
  parameters: string;
  qnh: number;
  oat: number;
}
export class flightlistStruct {
  flightId: string;
  creationDate: Date;
  flightNumber: string;
  author: string;
  actBlocksOffTime: Date;
  actDepTime: Date;
  actArrTime: Date;
  actBlocksOnTime: Date;
  codeDescription: string;
  acftReg: string;
  acftType: string;
  opsType: string;
  opsMissionType: string;
  estTimeDep: Date;
  estTimeArr: Date;
  estTimeDep_gui: string;
  estTimeArr_gui: string;
  flightrules: string;
  icaoOrigin: string;
  icaoDest: string;
  icaoAlternate: string;
  identOrigin: string;
  identDest: string;
  identAlternate: string;
  fplState: string;
  pilotInCommand: string;
  routeDistance_gui: string;
  routeTime_guid: string;
  routeCoords: string;
}
export class parameterStruct {
  parameter: property;
  tableSuffix: string;
  value: string;
  blob: string;
  json: string;
  geoJson: string;
  markdown: string;
}
export class focUnitStruct {
  fuelUnit: weightUnitEnum;
}
export class focSettingsStruct {
  homebase: airportHeliportStruct;
  useLocalTime: boolean = true;
  units: focUnitStruct;
}
export enum msgCatStruct {
  warn = 1,
  err = 2,
  nil = 3,
}
export enum weightUnitEnum {
  kg = 1,
  lbs = 2,
  liters = 3,
}
export class airportHeliportStruct {
  id: string;
  icaoCode: string;
  txtName: string;
  codeType: string;
  geoPos: [number, number];
  distSortNumber: number;
}
export class airportHeliportSearchStruct {
  public key: string = "";
  public icaoCode: string = "";
  public type: string = "";
  public name: string = "";
  public geoPos: number[];
  public eet: string = "";
  public distNm: string = "";
  public distSortNumber: number;
  public wx: string = "n/a";
}
export enum wTurbCatStuct {
  l = 1,
  m = 2,
  h = 3,
}
export enum crusingSpeedRefStruct {
  n = 1,
  m = 2,
}
export enum vertLevelRefStruct {
  alt = 1,
  fl = 2,
  vfr = 3,
}
export enum pointType {
  ahp = 0,
  vor = 1,
  dme = 2,
  dpn = 3,
}

// performance
export enum perfResultsEnum {
  hoge = 0,
  vne = 1,
  cat_a_vtol_maxGrossMass = 2,
  cat_a_climboutSegOne_height_over_100ft = 3,
  maxOperatingAlt = 4,
  maxGrossMass = 7,
  withinLoadAndBalanceEnvelope_lateral = 5,
  withinLoadAndBalanceEnvelope_longitudinal = 6,
  maxWinchMassLimit_preloading = 8,
}

export const availFx = [
  "initFlightShort(aircraftReg: string, origin: string, dest: string, alternate: string, estDepTime: Date, flightrules: flightRulesEnum, pilotInCommand: string, flightNumber: string, author: string)",
  "authorizeDutyLimits(dutyDesig: string, picName: string, missionLimits: dutyAuthStruct, parameters:string, dutyFrom:Date, dutyTo:Date, pin:string)",
  "initFlight(aircraftReg: string,    origin: string,    dest: string, alternate :string,  estDepTime: Date,   flightrules: flightRulesEnum,   pilotInCommand: string,  flightNumber: string , author : string, typeOfFlight:typeOfFlightStruct, crusingLevel : string, crusingLevelRef : vertLevelRefStruct, route:string,estTimeEnr:string, fplRemarks:string, estRouteDst : number)",
  "listAllFlightsByAuthor(date, author)",
  "getDutyLimits(pin: string)",
  "listAllFlights(date)",
  "deleteFlight(flightId)",
  "delayFlight(flightNumber:string, flightId:string, minDelay : number)",
  "bringFlightForward(flightNumber:string, flightId:string, minDelay : number)",
  "changeOrigin(flightNumber:string, flightId:string, newCode : string)",
  "changeDestination(flightNumber:string, flightId:string, newCode : string)",
  "changeAlternate(flightNumber:string, flightId:string, newCode : string)",
  "changeFlightRules(flightNumber:string, flightId:string, flightrules : flightRulesEnum)",
  "addRevertFlight(flightNumberOld:string, flightId:string, newDepTime : Date, newFlightNumber :string, newAlternate : string)",
  "changeAircraft(flightNumber:string, flightId:string, currRegistration : string, newRegistration :string)",
  "changeFlightNumber(flightNumber:string, flightId:string,  newFlightNumber :string)",
  "setActualBlocksOffTime(flightId:string)",
  "setActualDepartureTime(flightId:string)",
  "setActualArrivalTime(flightId:string)",
  "setActualBlocksOnTime(flightId:string)",
  "findAirport(qeruy:string)",
  "getAircraftRegistrations()",
  "getAircraftData(registration:String)",
  "nearestAirportHeliport([x}[y])",
  "getCurrentFlightCrew(time)",
  "getCompanyCrewList()",
  "getCrewAndCargo(dutyId: number)",
  "getListCargoConfigs(dutyId: number)",
  "getBookedCargo(dutyId: number, paraFilter: string)",
  "getBookedPassengers(dutyId: number)",
  "getBookedPassengersNotOnAircraft(dutyId: number)",
  "getBookedCargoNotOnAircraft(dutyId: number)",
  "pushCrewAndCargoToAcft(dutyId: number, crewCargo: CrewCargokeyValueStruct[])",
  "getLoadsheetPassengers(reg:string)",
  "getEmptySeats(reg:string)",
  "getLoadsheetCargo(reg:string)",
  "getAircraftCrew(reg:string)",
  "getEmtpySeats(reg:string)",
  "getmaxUsableFuelCapacity(reg:string)",
  "getMaxUsableFuelCapacityOfAircraft(reg:string)",
  "getCurrentBlockFuelOfAircraft(reg:string)",
  "getNbrOfSeats(reg:string)",
  "getFplTemplates(dutyId:number)",
  "initMassAndBalance(flightId:string, opsMissionType:opsMissionTypeEnum, parameters:string,personsAboard:number)",
  "initFlightOfDuty(aircraftReg: string, origin: string, dest: string, alternate: string, estDepTime: Date, author: string)",
  "initNav(flightId:string,terrDataUrl:string)",
  "initFuel(flightId:string,fuelOnBoard:number)",
  "getAircraftDataHtml(aircraftReg: string)",
  "getLoadAndBalanceMarkdown(acftRegistration: string, flightId: string, opsMissionType: opsMissionTypeEnum)",
  "getCrewHtml(referenceTime: number, acftReg: string)",
  "getNavHtmlReport(flightId:string)",
  "getFuelHtmlReport(flightId:string,opsMissionType:opsMissionTypeEnum)",
  "getLoadAndBalanceHtmlReport(acft: aircraftStruct, flightId: string, opsMissionType: opsMissionTypeEnum)",
  "getBriefgFlowOfFlight(allFlightsByThisAuthor, classCom,webcamLiveBaseUrl,webcamToolId,metarToolId)",
  "initNotam(flightId:string)",
  "getNotamHtml(flightId:string)",
  "initMet(flightId:string)",
  "getMetHtml(flightId:string)",
  "initPerformance(flightId:string)",
  "getPerformanceHtml(flightId:string)",
  "estimateMassAndBalance(flightCrewid: string,opsMissionType: opsMissionTypeEnum, extraWeight: number, personsAboard: number, fuelOnBoard: number, aircraftRegistration: string)",
  "setAircraftReg(registration: string)",
  "ac(registration: string)", //just a short version of setAircraftReg
  "getHoistRatingLoadOfOpsMissionTypeAndLmc(dutyId: string, opsMissionType: opsMissionTypeEnum, fuelLoading: number, extraweight: number, personsAboard: number)",
  "getHoistRatingLoadOfAllActiveMissionTypes(dutyId: string, fuelLoading: number, extraweight: number, personsAboard: number, opsMissionTypesSelected?: opsMissionTypeEnum[])",
  "getHoistRatingLoadOfAllActiveMissionTypes_forFlight(flightId: string,fuelLoading: number,extraweight: number,personsAboard: number,   opsMissionTypesSelected?: opsMissionTypeEnum[])",
  "getHoistRatingLoadOfAllActiveMissionTypes_ofDuty(dutyId: string,fuelLoading: number,extraweight: number,personsAboard: number, opsMissionTypesSelected: opsMissionTypeEnum[])",
];

export interface LiveValue {
  key: string[]; // a label path, e.g. ["Hoist", "PPOS"]
  value: number[]; // one or more numbers to plot / show
  md_report: string; // if you’re building a markdown report later
  svg: string; // any inline SVG markup you want to return
  annunciators: string; // text for the annunciator bar
}
